import { render, staticRenderFns } from "./DataKeanggotaan.vue?vue&type=template&id=4a148c74&"
import script from "./DataKeanggotaan.vue?vue&type=script&lang=js&"
export * from "./DataKeanggotaan.vue?vue&type=script&lang=js&"
import style0 from "./DataKeanggotaan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports